import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { PageBase } from "../../../Components/PageBase";
import "./PerfilUsuario.css";
import back from "../../../icons/arrow-back.svg";
import avatar from '../../../icons/avatar.png';
import img from "../../../icons/security.jpg";
import flechas from '../../../icons/swap-horizontal.svg';
import trash from '../../../icons/trash.svg';
import { useRol } from "../../../Context";



function PerfilUsuario() {
    const { dataUser, projects, tradeNames } = useRol()

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');

    const [seleccionado, setSeleccionado] = useState("perfil");
    const cambiarSeleccion = (opcion) => {
        setSeleccionado(opcion);
    };

    useEffect(() => {
        setUsername(dataUser?.username)
        setEmail(dataUser?.email)
        setFirst_name(dataUser?.first_name)
        setLast_name(dataUser?.last_name)
    }, [dataUser])

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="margenes-generales-perfilContacto">
                    <div className="contenedor-principal-perfilContacto">
                        <div className="apartado-perfil-perfilContacto">
                            <NavLink to={'/Equipo'} className="nav-links">
                                <div className="button-back-perfilContacto">
                                    <img src={back} alt="back" />
                                    <label>Regresar a tablero usuarios</label>
                                </div>
                            </NavLink>
                            <div className="data-profile-perfilContacto">
                                <div className="data-profile-perfilContacto">
                                    <div className="img-profile-perfilUsuario">
                                        <img src={avatar} alt="avatar" />
                                    </div>
                                    <div className="name-profile-perfilUsuario">
                                        <label>{dataUser?.first_name}</label>
                                    </div>
                                    <div className="email-profile-perfilUsuario">
                                        <label>{dataUser?.email}</label>
                                    </div>
                                    <div className="button-eliminar-perfilUsuario">
                                        <button>ELIMINAR</button>
                                    </div>
                                </div>
                                <div className="menu-profile-perfilContacto">
                                    <div className={`opcion ${seleccionado === "perfil" ? "seleccionado" : ""}`} onClick={() => cambiarSeleccion("perfil")}>
                                        Perfil
                                    </div>
                                    <div className={`opcion ${seleccionado === "contraseña" ? "seleccionado" : ""} sin`} onClick={() => cambiarSeleccion("contraseña")}>
                                        Cambiar contraseña
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="apartado-info-perfilContacto">
                            {seleccionado === "perfil" && <div className="info-margen-perfilContacto">
                                <div className="title-profile-info-perfilContacto">
                                    <label>Información del usuario</label>
                                </div>
                                <div className="container-addUser-main-modal">
                                    <div className="container-inputs-selects-addUser-modal">
                                        <div className="item-container-inputs-selects-addUser-perfilUsuario">
                                            <div className="item-label-addUser-perfilUsuario">
                                                <label>Usuario</label>
                                            </div>
                                            <div className="item-inputs-addUser-perfilUsuario">
                                                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="item-container-inputs-selects-addUser-perfilUsuario">
                                            <div className="item-label-addUser-perfilUsuario">
                                                <label>Correo</label>
                                            </div>
                                            <div className="item-inputs-addUser-perfilUsuario">
                                                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="item-container-inputs-selects-addUser-perfilUsuario">
                                            <div className="item-label-addUser-perfilUsuario">
                                                <label>Nombre</label>
                                            </div>
                                            <div className="item-inputs-addUser-perfilUsuario">
                                                <input type="text" value={first_name} onChange={(e) => setFirst_name(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="item-container-inputs-selects-addUser-perfilUsuario">
                                            <div className="item-label-addUser-perfilUsuario">
                                                <label>Apellido</label>
                                            </div>
                                            <div className="item-inputs-addUser-perfilUsuario">
                                                <input type="text" value={last_name} onChange={(e) => setLast_name(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="item-container-inputs-selects-addUser-perfilUsuario">
                                            <div className="item-label-addUser-perfilUsuario">
                                                <label>Rol</label>
                                            </div>
                                            <div className="item-inputs-addUser-perfilUsuario">
                                                <select>
                                                    <option value="1">Asesor</option>
                                                    <option value="2">Coordinador</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="container-empresa-addUser-modal">
                                    <div className="label-empresa-addUser-modal">
                                        <label>Empresa</label>
                                    </div>
                                    <div className="cuadros-empresa-addUser-modal">
                                        <div className="cuadro-empresa">
                                            {projects?.map((company) => {
                                                // Verifica si el trade_name ya existe en tradeNames
                                                if (!tradeNames.includes(company.trade_name)) {
                                                    return (
                                                        <div key={company.id} className="titulo-cuadro-empresa">
                                                            {company.trade_name}
                                                        </div>
                                                    );
                                                }
                                                return null; // Si ya existe, no renderiza el elemento
                                            })}
                                        </div>
                                        <div className="container-button-empresa-addUser-modal">
                                            <button>
                                                <img src={flechas} alt="flechas" />
                                            </button>
                                        </div>
                                        <div className="cuadro-empresa">
                                            {tradeNames.map((tradeName, index) => (
                                                <div key={index} className="titulo-cuadro-empresa">
                                                    {tradeName}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="buttons-container-modal">
                                    <button className="btn-acept-modal">Actualizar perfil</button>
                                </div>
                            </div>}
                            {seleccionado === "contraseña" && <div className="info-margen-perfilContacto">
                                <div className="title-profile-info-perfilContacto">
                                    <label>Cambio de contraseña</label>
                                </div>
                                <div className="contraseña-porlet-card">
                                    <div className="contraseña-form-container">
                                        <h2>Cambio de contraseña</h2>
                                        <p>Su contraseña no puede ser similar a su otra información personal. Debe contener al menos 8 caracteres y no puede ser enteramente numérica.</p>
                                        <div className="form-data-contraseña">
                                            <label>Contraseña antigua:</label>
                                            <input />
                                        </div>
                                        <div className="form-data-contraseña">
                                            <label>Contraseña nueva:</label>
                                            <input />
                                        </div>
                                        <div className="form-data-contraseña">
                                            <label>Confirmación de contraseña nueva:</label>
                                            <input />
                                        </div>
                                        <div className="form-data-contraseña">
                                            <button>Cambiar contraseña</button>
                                        </div>
                                    </div>
                                    <div className="contraseña-img-container">
                                        <img src={img} alt="security" />
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="perfilUsuario-movil">
                <div className="container-main-movil">
                    <NavLink to={'/Equipo'} className="nav-links-movil">
                        <div className="button-back-perfilContacto-movil">
                            <img src={back} alt="back" />
                            <label>Regresar a tablero usuarios</label>
                        </div>
                    </NavLink>
                    <div className="lead-card-perfilContacto-movil">
                        <div className="container-data-lead-movil">
                            <div className="emoji-lead-perfilContacto-movil">
                                <img src={avatar} alt="avatar" />
                            </div>
                            <div className="data-lead-perfilContacto-movil">
                                <label className="name-lead-movil">Jahir</label>
                                <div className="email-profile-perfilUsuario-movil">
                                    <label>rodrigo.lopez9810@gmail.com</label>
                                </div>
                            </div>
                            <div className="button-eliminar-perfilUsuario-movil">
                                <button>
                                    <img src={trash} alt="trash" />
                                </button>
                            </div>
                        </div>
                        <div className="container-buttons-lead-movil">
                            <div className={`opcion ${seleccionado === "perfil" ? "seleccionado-movil" : ""} lead-detalles-perfilUsuario-movil `} onClick={() => cambiarSeleccion("perfil")}>
                                <label>Perfil</label>
                            </div>
                            <div className={`opcion ${seleccionado === "tareas" ? "seleccionado-movil" : ""} lead-detalles-perfilUsuario-movil sin-movil`} onClick={() => cambiarSeleccion("tareas")}>
                                <label>Cambiar contraseña</label>
                            </div>
                        </div>
                    </div>
                    {seleccionado === "perfil" && <div className="info-margen-perfilContacto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Información del usuario</label>
                        </div>
                        <div className="container-data-perfilProyecto-movil">
                            <div className="data-perfilProyecto-movil">
                                <label>Usuario:</label>
                                <input value="jahir" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Correo:</label>
                                <input value="rodrigo.lopez9810@gmail.com" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Nombre:</label>
                                <input value="Jahir" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Apellido:</label>
                                <input value="Duarte" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Rol:</label>
                                <select value={"3"}>
                                    <option value="1">Asesor</option>
                                    <option value="2">Coordinador</option>
                                    <option value="3">Administrador</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Empresa:</label>
                                <div className="cuadros-empresa-addUser-modal">
                                    <div className="cuadro-empresa-movil">
                                        <div className="titulo-cuadro-empresa">
                                            Desarrollo México Habita
                                        </div>
                                    </div>
                                    <div className="container-button-empresa-addUser-modal">
                                        <button>
                                            <img src={flechas} alt="flechas" />
                                        </button>
                                    </div>
                                    <div className="cuadro-empresa-movil">

                                    </div>
                                </div>
                            </div>
                            <button className="btn-actualizar-perfilProyecto-movil">Actualizar Perfil</button>
                        </div>
                    </div>}
                    {seleccionado === "tareas" && <div className="info-margen-perfilContacto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Cambio de contraseña</label>
                        </div>
                        <div className="container-data-perfilUsuario-movil">
                            <p>Su contraseña no puede ser similar a su otra información personal. Debe contener al menos 8 caracteres y no puede ser enteramente numérica.</p>
                            <div className="contenido-password-item-data-movil">
                                <label>Contraseña antigua:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <label>Contraseña nueva:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <label>Confirmacion de contraseña antigua:</label>
                                <input />
                            </div>
                            <div className="contenido-password-item-data-movil">
                                <button>Cambiar contraseña</button>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

export { PerfilUsuario }